export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        width: '100%',
        '& .ProseMirror': {
            width: '100%',
            height: '100%',
            padding: '10px 36px 10px 12px',
            boxSizing: 'border-box',
            '& p, & ol, & ul': {
                margin: 0,
            },
            '& ol, & ul': {
                paddingLeft: 20,
            },
        },
        '& .ProseMirror:focus': {
            outline: 'none !important',
        },
        '& .ProseMirror p.is-editor-empty:first-child': {
            position: 'relative',
            overflow: 'hidden',
        },
        '& .ProseMirror p.is-editor-empty:first-child::before': {
            content: 'attr(data-placeholder)',
            color: theme.colors.textLight.disabled,
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
        },
        '& [data-type="emoji"]': {
            lineHeight: 1,
        },
        '& [data-type="mention"]': {
            display: 'inline-block',
            backgroundColor: alphaColor(theme.colors.textLight.jadeAccessible, 0.1),
            color: theme.colors.textLight.jadeAccessible,
            padding: '0 6px',
            borderRadius: 10,
            '&::selection': {
                color: theme.colors.utility.textSecondary,
                backgroundColor: theme.colors.background.jadeT7,
            },
        },
    },
    actionIcon: {
        position: 'absolute',
        top: 9,
        right: 9,
    },
    editorWrapper: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'column nowrap',
        width: '100%',
        alignItems: 'stretch',
        boxSizing: 'border-box',
        padding: 0,
        borderRadius: 8,
        border: '1px solid transparent',
        backgroundColor: theme.colors.grey[50],
        transition: 'all 0.15s ease',
    },
    editorContainer: {
        ...theme.typography.body,
        ...theme.utils.selection,
        color: theme.colors.utility.textPrimary,
        cursor: 'text',
        width: '100%',
        minHeight: 80,
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.15s ease',
    },
    editor: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        flex: 1,
    },
    error: {
        '& $editorWrapper': {
            backgroundColor: theme.colors.primary.white,
            borderColor: theme.colors.semantic.negative500,
        },
    },
    focused: {
        '& $editorWrapper': {
            backgroundColor: theme.colors.primary.white,
            borderColor: theme.colors.actionMajor[500],
        },
        '&$isBasic': {
            '& $editorWrapper': {
                backgroundColor: theme.colors.grey[50],
                borderColor: 'transparent',
            },
        },
    },
    isFullWidth: {
        width: '100%',
        '& $editorWrapper': {
            width: '100%',
            flex: 1,
        },
        '& [class^="HoiPoi__Input"]': {
            width: '100%',
        },
    },
    isReadOnly: {
        '& $editorWrapper': {
            backgroundColor: theme.colors.primary.white,
            borderColor: theme.colors.grey[200],
        },
        '& $editorContainer': {
            color: theme.colors.utility.textSecondary,
        },
    },
    isBasic: {
        '& $editorWrapper': {
            display: 'flex',
            justifyContent: 'space-between',
            flexFlow: 'row',
            borderRadius: 20,
            alignItems: 'end',
        },
        '& $editorContainer': {
            width: 'calc(100% - 46px)',
            display: 'flex',
            alignItems: 'center',
            minHeight: 40,
        },
        '& .ProseMirror': {
            width: '100%',
            padding: '5px 0 5px 12px',
        },
    },
    basicStatic: {
        '& $editorContainer': {
            maxHeight: 30,
        },
        '& .ProseMirror': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            marginLeft: '2px',
        },
        '& [class*="basicSubmit"]': {
            margin: '8px 12px 8px 8px',
        },
        '& [class*="basicLoader"]': {
            margin: '9px 12px 10px 8px',
        },
    },
    hasFixedToolbar: {
        '& $editorWrapper': {
            border: 'none',
        },
    },
    compactMode: {
        '& $editorWrapper': {
            position: 'relative',
            border: 'none',
            borderRadius: 15,
        },
        '& $editorContainer': {
            minHeight: 30,
        },
        '& .ProseMirror': {
            padding: '5px 36px 0 12px',
        },
        '& .ProseMirror p.is-editor-empty:first-child::before': {
            fontSize: 12,
            color: theme.colors.grey[200],
        },
    },
    compactModeFocused: {
        '& $editorWrapper': {
            position: 'relative',
            border: 'none',
            borderRadius: 8,
            paddingBottom: 30,
        },
        '& $editorContainer': {
            minHeight: 50,
        },
        '& .ProseMirror': {
            padding: '10px 36px 0 12px',
        },
        '& .ProseMirror p.is-editor-empty:first-child::before': {
            fontSize: 14,
            color: theme.colors.grey[500],
        },
    },
    preComponent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 24,
        width: 'auto',
        margin: '5px 0 8px 12px',
    },
    topComponent: {
        padding: '8px 12px',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        marginTop: 8,
    },
    bottomComponent: {
        width: '100%',
        height: 24,
        padding: '0 12px',
        margin: '5px 0 8px',
        '&:empty': {
            display: 'none',
        },
    },
    hasTopComponent: {
        '& > [class*="InputWrapper"]': {
            paddingTop: 0,
        },
        '& $editorWrapper': {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
    },
});
import { alphaColor } from '@Sage/ssm-utils';
